
import { defineComponent, ref, reactive, watch, nextTick, onMounted, onBeforeUnmount, getCurrentInstance } from 'vue'
import { mapState, useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'

import COVERAPP from '@/utils/COVERAPP'

import PicParticles from '@/utils/PicParticles'

import { CountUp } from 'countup.js'

import Dots from './Dots.vue'
import Car from './Car.vue'
import Road from './Road.vue'
import Ring from './Ring.vue'

export default defineComponent({
    computed: {
        ...mapState(['activityData'])
    },
    components: {
        Dots,
        Car,
        Road,
        Ring
    },
    props: ['canChange'],
    setup (props, context) {
        const $store = useStore()
        const _this = getCurrentInstance() as any
        const $route = useRoute()
        const $router = useRouter()
        const COVER = _this.proxy.$common
        const carDataList = [
            {
                img: require('@/assets/img/consumption/car_color_icon.png'),
                row: 9,
                col: 6,
                ratio: 30.1 / 100
            },
            {
                img: require('@/assets/img/consumption/car_icon.png'),
                row: 9,
                col: 6,
                ratio: 32 / 100
            }
        ]
        let zhParticles: any = null
        let zhRmove = false

        const getParents = (node, name: string) => {
            const parent = node.parentNode
            if (!parent || !parent.className || parent.className.indexOf('.consumption-list') > -1) return false
            if (parent.className.indexOf(name) > -1) {
                return true
            }
            getParents(parent, name)
        }

        const CountUpStart = (node) => {
            const num = node.innerText
            let options = {}
            if (num.indexOf('.') > -1) {
                options = {
                    useGrouping: false,
                    decimalPlaces: num.split('.')[1].length,
                    decimal: '.',
                }
            }
            const countUp = new CountUp(node, node.innerText, options)
            countUp.start()
        }

        const numCountUp = (node) => {
            const cs = node.querySelectorAll('.count-up')
            if (node.className.indexOf('count-up') > -1) {
                CountUpStart(node)
            }
            for (let i = 0; i < cs.length; i++) {
                CountUpStart(cs[i])
            }
        }

        const commonEvent = () => {
            const list = document.querySelector('.consumption-wrapper .consumption-list') as HTMLDivElement
            const ps = list.querySelectorAll('p, .qipao-line')
            for (let i = 0; i < ps.length; i++) {
                const p = ps[i] as HTMLParagraphElement
                let t = p.getBoundingClientRect().top - window.innerHeight / 2
                if (getParents(p, 'shopping-item')) {
                    const cart = document.querySelector('.consumption-wrapper .cart') as HTMLDivElement
                    t = p.getBoundingClientRect().top - (window.innerHeight + cart.getBoundingClientRect().height) / 2
                }
                if (p.getBoundingClientRect().bottom - document.documentElement.scrollTop - p.getBoundingClientRect().bottom + document.documentElement.scrollTop <  window.innerHeight) {
                    t = p.getBoundingClientRect().bottom - window.innerHeight + window.innerWidth * .1
                }
                if (t <= 0) {
                    const cls = p.className
                    if (cls.indexOf('show') < 0) {
                        p.className += ' show'
                        numCountUp(p)
                    }
                }
            }
        }

        const zhEvent = () => {
            const zhItem = document.querySelector('.consumption-wrapper .zh-item') as HTMLDivElement
            if (zhItem.getBoundingClientRect().top - window.innerHeight / 2 < 0 && !zhParticles) {
                zhParticles = new PicParticles({
                    container: document.querySelector('.consumption-wrapper .zh-bg'),
                    imgUrl: require('../../assets/img/consumption/zh_bg.png'),
                    pix: 20,
                    duration: 2000
                })
            }
        }

        const dotEvent = (name) => {
            const dotsWrapper = document.querySelector(name) as HTMLDivElement
            const cls = dotsWrapper.className
            if (dotsWrapper.getBoundingClientRect().top - window.innerHeight / 2 < 0 && cls.indexOf('show') < 0) {
                dotsWrapper.className += ' show'
            }
        }

        const isShoppingShow = ref<boolean>(false)
        const carShowIndex = ref<number>(0)
        let lastScrollTop = 0
        const shoppingEvent = () => {
            const shoppingItem = document.querySelector('.consumption-wrapper .shopping-item') as HTMLDivElement
            // 购物车显示
            if (shoppingItem.getBoundingClientRect().top - window.innerHeight / 2 <= 0 && shoppingItem.getBoundingClientRect().bottom > window.innerWidth * 1.5) {
                isShoppingShow.value = true
            } else {
                isShoppingShow.value = false
            }
        }

        const ringShow = ref<boolean>(false)
        const ringEvent = () => {
            const ring = document.querySelector('.consumption-wrapper .ring-wrapper') as HTMLDivElement
            if (ring.getBoundingClientRect().top - window.innerHeight / 2 <= 0) {
                ringShow.value = true
            }
        }

        const scrollEvent = () => {
            commonEvent()
            zhEvent()
            dotEvent('.dots-container')
            dotEvent('.car-container')
            shoppingEvent()
            ringEvent()
        }

        let titleParticles: any = null

        const titleEvent = () => {
            const title = document.querySelector('.consumption-wrapper .title') as HTMLDivElement
            if (!titleParticles) {
                titleParticles = new PicParticles({
                    container: title,
                    imgUrl: require('../../assets/img/consumption/title_bg.png'),
                    pix: 25,
                    radius: 60,
                    duration: 2000
                })
            }
            
        }

        const init = () => {
            titleEvent()
            scrollEvent()
            window.addEventListener('scroll', scrollEvent, false)
        }

        watch(() => props.canChange, (to, from) => {
            if (to) {
                init()
            }
        })

        onBeforeUnmount(() => {
            if (titleParticles) {
                titleParticles.forceDestroy()
                titleParticles = null
            }
            if (zhParticles) {
                zhParticles.forceDestroy()
                zhParticles = null
            }
            window.removeEventListener('scroll', scrollEvent, false)
        })

        onMounted(() => {
            if(props.canChange) {
                init()
            }
        })    

        return {
            isShoppingShow,
            carDataList,
            carShowIndex,
            ringShow
        }
    }
})
